<template>
  <div id="sidebar" class="sidebar-system">
    <div class="m-4 position-relative">
      <div class="welcome-container">
        <div class="sidebar-welcome">
          {{ $t("welcome") }}, {{ userName.split(" ")[0] }}
        </div>

        <svg
          class="pointer close-icon"
          @click="$emit('clicked')"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.99999 4.82178L10.125 0.696777L11.3033 1.87511L7.17832 6.00011L11.3033 10.1251L10.125 11.3034L5.99999 7.17844L1.87499 11.3034L0.696655 10.1251L4.82166 6.00011L0.696655 1.87511L1.87499 0.696777L5.99999 4.82178Z"
            fill="white"
          />
        </svg>
      </div>

      <div class="divisor">
        <!--  <svg
          width="248"
          height="1"
          viewBox="0 0 259 1"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="259" height="1" rx="0.5" fill="#00B1EB" />
        </svg> -->
      </div>

      <div
        class="d-flex justify-content-between mt-1"
        @click="adminSection = !adminSection"
      >
        <p v-if="userType === 1" class="sidebar-section-title mt-4 pl-1">
          {{ $t("admin") }}
          <svg
            class="arrow-handle"
            :class="{ 'rotate-arrow': !adminSection }"
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.00011 3.02341L1.87511 7.14841L0.696777 5.97008L6.00011 0.666748L11.3034 5.97008L10.1251 7.14841L6.00011 3.02341Z"
              fill="white"
            />
          </svg>
        </p>
        <p v-if="userType === 2" class="sidebar-section-title mt-4 pl-1">
          {{ $t("oversight") }}
          <svg
            class="arrow-handle"
            :class="{ 'rotate-arrow': !adminSection }"
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.00011 3.02341L1.87511 7.14841L0.696777 5.97008L6.00011 0.666748L11.3034 5.97008L10.1251 7.14841L6.00011 3.02341Z"
              fill="white"
            />
          </svg>
        </p>
        <p v-if="userType === 3" class="sidebar-section-title mt-4 pl-1">
          {{ $t("monitoring") }}
          <svg
            class="arrow-handle"
            :class="{ 'rotate-arrow': !adminSection }"
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.00011 3.02341L1.87511 7.14841L0.696777 5.97008L6.00011 0.666748L11.3034 5.97008L10.1251 7.14841L6.00011 3.02341Z"
              fill="white"
            />
          </svg>
        </p>
        <p v-if="userType === 4" class="sidebar-section-title mt-4 pl-1">
          {{ $t("monitoringArea") }}
          <svg
            class="arrow-handle"
            :class="{ 'rotate-arrow': !adminSection }"
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.00011 3.02341L1.87511 7.14841L0.696777 5.97008L6.00011 0.666748L11.3034 5.97008L10.1251 7.14841L6.00011 3.02341Z"
              fill="white"
            />
          </svg>
        </p>
        <p v-if="userType === 5" class="sidebar-section-title mt-4 pl-1">
          Fiscal
          <svg
            class="arrow-handle"
            :class="{ 'rotate-arrow': !adminSection }"
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.00011 3.02341L1.87511 7.14841L0.696777 5.97008L6.00011 0.666748L11.3034 5.97008L10.1251 7.14841L6.00011 3.02341Z"
              fill="white"
            />
          </svg>
        </p>
      </div>

      <div v-if="adminSection && userType === 5">
        <div
          @click="routeTo('/mapa/fiscal/cidade')"
          class="d-flex mt-2 ml-1 mb-2 pointer menu-item"
          :class="actualRoute === '/mapa/fiscal/cidade' && 'active-item'"
        >
          <div class="icon-grid">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.19579 4.37758C3.13333 5.48032 2.48288 6.91521 2.35377 8.44105C2.22466 9.9669 2.62477 11.4907 3.48684 12.7563C4.34891 14.0218 5.62039 14.9521 7.08755 15.3906C8.55472 15.8291 10.1281 15.7492 11.5433 15.1642C11.6391 14.5392 11.4291 13.9392 11.3433 13.7292C11.1516 13.2626 10.52 12.4651 9.46579 11.3592C9.18413 11.0634 9.20246 10.8359 9.30329 10.1617L9.31413 10.0859C9.38246 9.62425 9.49746 9.35091 11.0516 9.10425C11.8416 8.97925 12.0491 9.29425 12.3366 9.73175L12.4333 9.87508C12.7066 10.2751 12.9091 10.3667 13.215 10.5051C13.3525 10.5676 13.5233 10.6467 13.7525 10.7759C14.2958 11.0867 14.2958 11.4376 14.2958 12.2059V12.2934C14.2958 12.6192 14.2641 12.9059 14.2141 13.1551C14.8536 12.3525 15.2992 11.4132 15.5163 10.4102C15.7334 9.40729 15.716 8.36777 15.4656 7.37261C15.2153 6.37745 14.7386 5.4535 14.0727 4.6727C13.4068 3.89189 12.5698 3.2753 11.6266 2.87091C11.1658 3.18175 10.5333 3.62258 10.3125 3.92508C10.2 4.07925 10.04 4.86841 9.52079 4.93341C9.38579 4.95008 9.20329 4.93841 9.00996 4.92591C8.49163 4.89258 7.78329 4.84675 7.55663 5.46258C7.41246 5.85258 7.38746 6.91258 7.85329 7.46258C7.92829 7.55008 7.94246 7.71258 7.89163 7.89508C7.82496 8.13425 7.69079 8.28008 7.64829 8.31008C7.56829 8.26341 7.40829 8.07758 7.29913 7.95175C7.03829 7.64758 6.71163 7.26841 6.28996 7.15175C6.13663 7.10925 5.96829 7.07425 5.80413 7.03925C5.34663 6.94341 4.82913 6.83425 4.70829 6.57758C4.61996 6.38925 4.62079 6.13008 4.62079 5.85675C4.62079 5.50925 4.62079 5.11675 4.45079 4.73591C4.39169 4.6 4.30484 4.47795 4.19579 4.37758ZM8.99996 17.3334C4.39746 17.3334 0.666626 13.6026 0.666626 9.00008C0.666626 4.39758 4.39746 0.666748 8.99996 0.666748C13.6025 0.666748 17.3333 4.39758 17.3333 9.00008C17.3333 13.6026 13.6025 17.3334 8.99996 17.3334Z"
                fill="#00B1EB"
              />
            </svg>
          </div>
          <div class="sidebar-link-label">{{ $t("home") }}</div>
        </div>
      </div>

      <div v-if="userType !== 5">
        <div v-if="adminSection">
          <div
            @click="homeRoute"
            class="d-flex mt-2 ml-1 mb-2 pointer menu-item"
            :class="actualRoute === '/dashboard' && 'active-item'"
          >
            <div class="icon-grid">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.19579 4.37758C3.13333 5.48032 2.48288 6.91521 2.35377 8.44105C2.22466 9.9669 2.62477 11.4907 3.48684 12.7563C4.34891 14.0218 5.62039 14.9521 7.08755 15.3906C8.55472 15.8291 10.1281 15.7492 11.5433 15.1642C11.6391 14.5392 11.4291 13.9392 11.3433 13.7292C11.1516 13.2626 10.52 12.4651 9.46579 11.3592C9.18413 11.0634 9.20246 10.8359 9.30329 10.1617L9.31413 10.0859C9.38246 9.62425 9.49746 9.35091 11.0516 9.10425C11.8416 8.97925 12.0491 9.29425 12.3366 9.73175L12.4333 9.87508C12.7066 10.2751 12.9091 10.3667 13.215 10.5051C13.3525 10.5676 13.5233 10.6467 13.7525 10.7759C14.2958 11.0867 14.2958 11.4376 14.2958 12.2059V12.2934C14.2958 12.6192 14.2641 12.9059 14.2141 13.1551C14.8536 12.3525 15.2992 11.4132 15.5163 10.4102C15.7334 9.40729 15.716 8.36777 15.4656 7.37261C15.2153 6.37745 14.7386 5.4535 14.0727 4.6727C13.4068 3.89189 12.5698 3.2753 11.6266 2.87091C11.1658 3.18175 10.5333 3.62258 10.3125 3.92508C10.2 4.07925 10.04 4.86841 9.52079 4.93341C9.38579 4.95008 9.20329 4.93841 9.00996 4.92591C8.49163 4.89258 7.78329 4.84675 7.55663 5.46258C7.41246 5.85258 7.38746 6.91258 7.85329 7.46258C7.92829 7.55008 7.94246 7.71258 7.89163 7.89508C7.82496 8.13425 7.69079 8.28008 7.64829 8.31008C7.56829 8.26341 7.40829 8.07758 7.29913 7.95175C7.03829 7.64758 6.71163 7.26841 6.28996 7.15175C6.13663 7.10925 5.96829 7.07425 5.80413 7.03925C5.34663 6.94341 4.82913 6.83425 4.70829 6.57758C4.61996 6.38925 4.62079 6.13008 4.62079 5.85675C4.62079 5.50925 4.62079 5.11675 4.45079 4.73591C4.39169 4.6 4.30484 4.47795 4.19579 4.37758ZM8.99996 17.3334C4.39746 17.3334 0.666626 13.6026 0.666626 9.00008C0.666626 4.39758 4.39746 0.666748 8.99996 0.666748C13.6025 0.666748 17.3333 4.39758 17.3333 9.00008C17.3333 13.6026 13.6025 17.3334 8.99996 17.3334Z"
                  fill="#00B1EB"
                />
              </svg>
            </div>
            <div class="sidebar-link-label">{{ $t("home") }}</div>
          </div>
          <router-link
            v-if="userType === 3"
            to="/dashboard-monitor"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            :class="actualRoute === '/dashboard-monitor' && 'active-item'"
          >
            <div
              class="d-flex ml-1"
              :class="
                verifyIfRouteContains('/dashboard-monitor') && 'active-item'
              "
            >
              <div class="icon-grid">
                <svg
                  width="20"
                  height="17"
                  viewBox="0 0 20 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.8334 16.4996H4.16671C3.94569 16.4996 3.73373 16.4118 3.57745 16.2555C3.42117 16.0992 3.33337 15.8873 3.33337 15.6663V8.16627H0.833374L9.43921 0.342941C9.59263 0.203339 9.79261 0.125977 10 0.125977C10.2075 0.125977 10.4074 0.203339 10.5609 0.342941L19.1667 8.16627H16.6667V15.6663C16.6667 15.8873 16.5789 16.0992 16.4226 16.2555C16.2664 16.4118 16.0544 16.4996 15.8334 16.4996ZM10.8334 14.8329H15V6.63044L10 2.08544L5.00004 6.63044V14.8329H9.16671V9.83294H10.8334V14.8329Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">Início</div>
            </div>
          </router-link>
          <router-link
            to="/atividades"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            :class="verifyIfRouteIsActive('/atividades') && 'active-item'"
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5 0.5V2.16667C15.5 10.1892 11.0225 13.8333 5.5 13.8333H2.36917C2.23333 14.5933 2.16667 15.4225 2.16667 16.3333H0.5C0.5 15.1975 0.596667 14.1667 0.788333 13.2233C0.596667 12.145 0.5 10.6817 0.5 8.83333C0.5 4.23083 4.23083 0.5 8.83333 0.5C10.5 0.5 12.1667 1.33333 15.5 0.5ZM8.83333 2.16667C5.15167 2.16667 2.16667 5.15167 2.16667 8.83333C2.16667 9.135 2.16917 9.42583 2.175 9.705C3.22 8.05667 4.75083 6.75417 6.75333 5.61L7.58 7.05667C5.20083 8.41667 3.6225 9.96167 2.81333 12.1667H5.5C10.5125 12.1667 13.7258 8.85583 13.8308 2.49C12.6875 2.60083 11.625 2.53 10.3142 2.33333C9.35583 2.18917 9.1675 2.16667 8.83333 2.16667Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">{{ $t("activities") }}</div>
            </div>
          </router-link>

          <router-link
            to="/pesquisas"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            v-if="this.userType === 1"
            :class="verifyIfRouteContains('/pesquisa') && 'active-item'"
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="16"
                  height="18"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.16667 4.83317H8.83333V13.1665H7.16667V4.83317ZM10.5 8.1665H12.1667V13.1665H10.5V8.1665ZM3.83333 9.83317H5.5V13.1665H3.83333V9.83317ZM10.5 2.33317H2.16667V15.6665H13.8333V5.6665H10.5V2.33317ZM0.5 1.49317C0.5 1.0365 0.8725 0.666504 1.3325 0.666504H11.3333L15.5 4.83317V16.494C15.5008 16.6034 15.48 16.712 15.4388 16.8134C15.3976 16.9148 15.3369 17.007 15.2601 17.085C15.1832 17.1629 15.0918 17.2249 14.991 17.2675C14.8902 17.3101 14.7819 17.3324 14.6725 17.3332H1.3275C1.10865 17.3316 0.899181 17.2441 0.744348 17.0894C0.589515 16.9347 0.501746 16.7254 0.5 16.5065V1.49317Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">Pesquisa</div>
            </div>
          </router-link>

          <router-link
            to="/areas-de-zeladoria"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            :class="
              verifyIfRouteIsActive('/areas-de-zeladoria') && 'active-item'
            "
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.6667 0.5C15.1267 0.5 15.5 0.873333 15.5 1.33333V14.6667C15.5 15.1267 15.1267 15.5 14.6667 15.5H1.33333C0.873333 15.5 0.5 15.1267 0.5 14.6667V1.33333C0.5 0.873333 0.873333 0.5 1.33333 0.5H14.6667ZM7.32417 8.965L2.16667 9.875V13.8333H8.18167L7.32333 8.965H7.32417ZM13.8333 2.16667H7.8175L9.87417 13.8333H13.8333V2.16667ZM6.125 2.16667H2.16667V8.18167L7.035 7.32333L6.125 2.16667Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">{{ $t("keepingSectors") }}</div>
            </div>
          </router-link>

          <router-link
            to="/bairros"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            :class="verifyIfRouteIsActive('/bairros') && 'active-item'"
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="18"
                  height="16"
                  viewBox="0 0 18 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.4998 15.5H1.49984C1.27882 15.5 1.06686 15.4122 0.910582 15.2559C0.754301 15.0996 0.666504 14.8877 0.666504 14.6667V8.40583C0.666491 8.28676 0.691996 8.16906 0.741302 8.06068C0.790608 7.95229 0.862568 7.85573 0.952337 7.7775L3.99984 5.12V1.33333C3.99984 1.11232 4.08763 0.900358 4.24392 0.744078C4.4002 0.587797 4.61216 0.5 4.83317 0.5H16.4998C16.7208 0.5 16.9328 0.587797 17.0891 0.744078C17.2454 0.900358 17.3332 1.11232 17.3332 1.33333V14.6667C17.3332 14.8877 17.2454 15.0996 17.0891 15.2559C16.9328 15.4122 16.7208 15.5 16.4998 15.5ZM6.49984 13.8333H8.99984V8.785L5.6665 5.87833L2.33317 8.785V13.8333H4.83317V10.5H6.49984V13.8333ZM10.6665 13.8333H15.6665V2.16667H5.6665V3.93917C5.8615 3.93917 6.05734 4.0075 6.214 4.145L10.3807 7.7775C10.4704 7.85573 10.5424 7.95229 10.5917 8.06068C10.641 8.16906 10.6665 8.28676 10.6665 8.40583V13.8333ZM12.3332 7.16667H13.9998V8.83333H12.3332V7.16667ZM12.3332 10.5H13.9998V12.1667H12.3332V10.5ZM12.3332 3.83333H13.9998V5.5H12.3332V3.83333ZM8.99984 3.83333H10.6665V5.5H8.99984V3.83333Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">{{ $t("neighborhoods") }}</div>
            </div>
          </router-link>

          <router-link
            to="/instituicoes"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            v-if="this.userType === 1"
            :class="verifyIfRouteIsActive('/instituicoes') && 'active-item'"
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.83317 4.16671V1.66671C4.83317 1.44569 4.92097 1.23373 5.07725 1.07745C5.23353 0.921171 5.44549 0.833374 5.6665 0.833374H12.3332C12.5542 0.833374 12.7661 0.921171 12.9224 1.07745C13.0787 1.23373 13.1665 1.44569 13.1665 1.66671V4.16671H16.4998C16.7209 4.16671 16.9328 4.25451 17.0891 4.41079C17.2454 4.56707 17.3332 4.77903 17.3332 5.00004V16.6667C17.3332 16.8877 17.2454 17.0997 17.0891 17.256C16.9328 17.4122 16.7209 17.5 16.4998 17.5H1.49984C1.27882 17.5 1.06686 17.4122 0.910582 17.256C0.754301 17.0997 0.666504 16.8877 0.666504 16.6667V5.00004C0.666504 4.77903 0.754301 4.56707 0.910582 4.41079C1.06686 4.25451 1.27882 4.16671 1.49984 4.16671H4.83317ZM2.33317 13.3334V15.8334H15.6665V13.3334H2.33317ZM2.33317 11.6667H15.6665V5.83337H2.33317V11.6667ZM6.49984 2.50004V4.16671H11.4998V2.50004H6.49984ZM8.1665 9.16671H9.83317V10.8334H8.1665V9.16671Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">{{ $t("institutions") }}</div>
            </div>
          </router-link>

          <router-link
            to="/associacoes"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            v-if="this.userType === 1"
            :class="verifyIfRouteIsActive('/associacoes') && 'active-item'"
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.99984 8.16663C10.1049 8.16663 11.1647 8.60561 11.9461 9.38701C12.7275 10.1684 13.1665 11.2282 13.1665 12.3333V17.3333H11.4998V12.3333C11.4999 11.6956 11.2562 11.082 10.8188 10.6181C10.3813 10.1541 9.78308 9.87487 9.1465 9.83746L8.99984 9.83329C8.36216 9.83326 7.74858 10.0769 7.28462 10.5144C6.82066 10.9518 6.54141 11.55 6.504 12.1866L6.49984 12.3333V17.3333H4.83317V12.3333C4.83317 11.2282 5.27216 10.1684 6.05356 9.38701C6.83496 8.60561 7.89477 8.16663 8.99984 8.16663ZM3.58317 10.6666C3.81567 10.6666 4.0415 10.6941 4.25817 10.745C4.11569 11.1691 4.03131 11.6106 4.00734 12.0575L3.99984 12.3333V12.405C3.90405 12.3707 3.80441 12.3483 3.70317 12.3383L3.58317 12.3333C3.27244 12.3333 2.97284 12.4491 2.74282 12.658C2.5128 12.8669 2.36883 13.154 2.339 13.4633L2.33317 13.5833V17.3333H0.666504V13.5833C0.666504 12.8097 0.973795 12.0679 1.52078 11.5209C2.06776 10.9739 2.80962 10.6666 3.58317 10.6666ZM14.4165 10.6666C15.1901 10.6666 15.9319 10.9739 16.4789 11.5209C17.0259 12.0679 17.3332 12.8097 17.3332 13.5833V17.3333H15.6665V13.5833C15.6665 13.2726 15.5507 12.973 15.3418 12.7429C15.1329 12.5129 14.8458 12.369 14.5365 12.3391L14.4165 12.3333C14.2707 12.3333 14.1307 12.3583 13.9998 12.4041V12.3333C13.9998 11.7783 13.9098 11.245 13.7423 10.7466C13.9582 10.6941 14.184 10.6666 14.4165 10.6666ZM3.58317 5.66663C4.1357 5.66663 4.66561 5.88612 5.05631 6.27682C5.44701 6.66752 5.6665 7.19743 5.6665 7.74996C5.6665 8.30249 5.44701 8.8324 5.05631 9.2231C4.66561 9.6138 4.1357 9.83329 3.58317 9.83329C3.03064 9.83329 2.50073 9.6138 2.11003 9.2231C1.71933 8.8324 1.49984 8.30249 1.49984 7.74996C1.49984 7.19743 1.71933 6.66752 2.11003 6.27682C2.50073 5.88612 3.03064 5.66663 3.58317 5.66663ZM14.4165 5.66663C14.969 5.66663 15.4989 5.88612 15.8896 6.27682C16.2803 6.66752 16.4998 7.19743 16.4998 7.74996C16.4998 8.30249 16.2803 8.8324 15.8896 9.2231C15.4989 9.6138 14.969 9.83329 14.4165 9.83329C13.864 9.83329 13.3341 9.6138 12.9434 9.2231C12.5527 8.8324 12.3332 8.30249 12.3332 7.74996C12.3332 7.19743 12.5527 6.66752 12.9434 6.27682C13.3341 5.88612 13.864 5.66663 14.4165 5.66663ZM3.58317 7.33329C3.47266 7.33329 3.36668 7.37719 3.28854 7.45533C3.2104 7.53347 3.1665 7.63945 3.1665 7.74996C3.1665 7.86047 3.2104 7.96645 3.28854 8.04459C3.36668 8.12273 3.47266 8.16663 3.58317 8.16663C3.69368 8.16663 3.79966 8.12273 3.8778 8.04459C3.95594 7.96645 3.99984 7.86047 3.99984 7.74996C3.99984 7.63945 3.95594 7.53347 3.8778 7.45533C3.79966 7.37719 3.69368 7.33329 3.58317 7.33329ZM14.4165 7.33329C14.306 7.33329 14.2 7.37719 14.1219 7.45533C14.0437 7.53347 13.9998 7.63945 13.9998 7.74996C13.9998 7.86047 14.0437 7.96645 14.1219 8.04459C14.2 8.12273 14.306 8.16663 14.4165 8.16663C14.527 8.16663 14.633 8.12273 14.7111 8.04459C14.7893 7.96645 14.8332 7.86047 14.8332 7.74996C14.8332 7.63945 14.7893 7.53347 14.7111 7.45533C14.633 7.37719 14.527 7.33329 14.4165 7.33329ZM8.99984 0.666626C9.88389 0.666626 10.7317 1.01782 11.3569 1.64294C11.982 2.26806 12.3332 3.1159 12.3332 3.99996C12.3332 4.88401 11.982 5.73186 11.3569 6.35698C10.7317 6.9821 9.88389 7.33329 8.99984 7.33329C8.11578 7.33329 7.26794 6.9821 6.64281 6.35698C6.01769 5.73186 5.6665 4.88401 5.6665 3.99996C5.6665 3.1159 6.01769 2.26806 6.64281 1.64294C7.26794 1.01782 8.11578 0.666626 8.99984 0.666626ZM8.99984 2.33329C8.55781 2.33329 8.13389 2.50889 7.82133 2.82145C7.50877 3.13401 7.33317 3.55793 7.33317 3.99996C7.33317 4.44199 7.50877 4.86591 7.82133 5.17847C8.13389 5.49103 8.55781 5.66663 8.99984 5.66663C9.44186 5.66663 9.86579 5.49103 10.1783 5.17847C10.4909 4.86591 10.6665 4.44199 10.6665 3.99996C10.6665 3.55793 10.4909 3.13401 10.1783 2.82145C9.86579 2.50889 9.44186 2.33329 8.99984 2.33329Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">{{ $t("associations") }}</div>
            </div>
          </router-link>

          <a
            target="_blank"
            href="https://cidadeama.com.br/termos-ama-empreendedor/"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            v-if="
              this.userType === 2 || this.userType === 3 || this.userType === 4
            "
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="16"
                  height="18"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.83333 4.00008V1.50008C3.83333 1.27907 3.92113 1.06711 4.07741 0.910826C4.23369 0.754545 4.44565 0.666748 4.66667 0.666748H14.6667C14.8877 0.666748 15.0996 0.754545 15.2559 0.910826C15.4122 1.06711 15.5 1.27907 15.5 1.50008V13.1667C15.5 13.3878 15.4122 13.5997 15.2559 13.756C15.0996 13.9123 14.8877 14.0001 14.6667 14.0001H12.1667V16.5001C12.1667 16.9601 11.7917 17.3334 11.3275 17.3334H1.33917C1.22927 17.3341 1.12033 17.313 1.0186 17.2714C0.916873 17.2299 0.824361 17.1686 0.746382 17.0912C0.668403 17.0137 0.606494 16.9216 0.564212 16.8202C0.52193 16.7188 0.500108 16.61 0.5 16.5001L0.5025 4.83342C0.5025 4.37342 0.8775 4.00008 1.34083 4.00008H3.83333ZM2.16833 5.66675L2.16667 15.6667H10.5V5.66675H2.16833ZM5.5 4.00008H12.1667V12.3334H13.8333V2.33341H5.5V4.00008ZM3.83333 8.16675H8.83333V9.83342H3.83333V8.16675ZM3.83333 11.5001H8.83333V13.1667H3.83333V11.5001Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>

              <div class="sidebar-link-label">{{ $t("termsPolicies") }}</div>
            </div>
          </a>

          <router-link
            to="/politicas"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            v-if="this.userType === 1"
            :class="verifyIfRouteIsActive('/politicas') && 'active-item'"
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="16"
                  height="18"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.83333 4.00008V1.50008C3.83333 1.27907 3.92113 1.06711 4.07741 0.910826C4.23369 0.754545 4.44565 0.666748 4.66667 0.666748H14.6667C14.8877 0.666748 15.0996 0.754545 15.2559 0.910826C15.4122 1.06711 15.5 1.27907 15.5 1.50008V13.1667C15.5 13.3878 15.4122 13.5997 15.2559 13.756C15.0996 13.9123 14.8877 14.0001 14.6667 14.0001H12.1667V16.5001C12.1667 16.9601 11.7917 17.3334 11.3275 17.3334H1.33917C1.22927 17.3341 1.12033 17.313 1.0186 17.2714C0.916873 17.2299 0.824361 17.1686 0.746382 17.0912C0.668403 17.0137 0.606494 16.9216 0.564212 16.8202C0.52193 16.7188 0.500108 16.61 0.5 16.5001L0.5025 4.83342C0.5025 4.37342 0.8775 4.00008 1.34083 4.00008H3.83333ZM2.16833 5.66675L2.16667 15.6667H10.5V5.66675H2.16833ZM5.5 4.00008H12.1667V12.3334H13.8333V2.33341H5.5V4.00008ZM3.83333 8.16675H8.83333V9.83342H3.83333V8.16675ZM3.83333 11.5001H8.83333V13.1667H3.83333V11.5001Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">{{ $t("termsPolicies") }}</div>
            </div>
          </router-link>

          <!-- AQUIIIIIIIIIIII -->
          <router-link
            to="/ordens-de-servico"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            v-if="this.userType !== 4 && getConfig500() !== 0"
            :class="
              verifyIfRouteIsActive('/ordens-de-servico') && 'active-item'
            "
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.6665 2.5V4.16667H2.33317V15.3208L3.80234 14.1667H15.6665V8.33333H17.3332V15C17.3332 15.221 17.2454 15.433 17.0891 15.5893C16.9328 15.7455 16.7208 15.8333 16.4998 15.8333H4.379L0.666504 18.75V3.33333C0.666504 3.11232 0.754301 2.90036 0.910582 2.74408C1.06686 2.5878 1.27882 2.5 1.49984 2.5H10.6665ZM14.8332 2.5V0H16.4998V2.5H18.9998V4.16667H16.4998V6.66667H14.8332V4.16667H12.3332V2.5H14.8332Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">{{ $t("ServiceOrder") }}</div>
            </div>
          </router-link>
        </div>

        <div
          class="d-flex"
          v-if="userType !== 3 && userType !== 2"
          @click="supervisorSection = !supervisorSection"
        >
          <p class="sidebar-section-title mt-4 pl-1">
            FISCAIS
            <svg
              class="arrow-handle"
              :class="{ 'rotate-arrow': !supervisorSection }"
              width="12"
              height="8"
              viewBox="0 0 12 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.00011 3.02341L1.87511 7.14841L0.696777 5.97008L6.00011 0.666748L11.3034 5.97008L10.1251 7.14841L6.00011 3.02341Z"
                fill="white"
              />
            </svg>
          </p>
        </div>

        <div class="mt-3" v-if="supervisorSection">
          <router-link
            to="/tipos-fiscal"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            v-if="this.userType === 1"
            :class="verifyIfRouteIsActive('/tipos-fiscal') && 'active-item'"
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="17"
                  height="20"
                  viewBox="0 0 17 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.99998 11.6667V13.3333C5.6739 13.3333 4.40213 13.8601 3.46445 14.7978C2.52676 15.7355 1.99998 17.0072 1.99998 18.3333H0.333313C0.333313 16.5652 1.03569 14.8695 2.28593 13.6193C3.53618 12.369 5.23187 11.6667 6.99998 11.6667ZM6.99998 10.8333C4.23748 10.8333 1.99998 8.59583 1.99998 5.83333C1.99998 3.07083 4.23748 0.833328 6.99998 0.833328C9.76248 0.833328 12 3.07083 12 5.83333C12 8.59583 9.76248 10.8333 6.99998 10.8333ZM6.99998 9.16666C8.84165 9.16666 10.3333 7.67499 10.3333 5.83333C10.3333 3.99166 8.84165 2.49999 6.99998 2.49999C5.15831 2.49999 3.66665 3.99166 3.66665 5.83333C3.66665 7.67499 5.15831 9.16666 6.99998 9.16666ZM14.8716 16.6933L16.125 17.9467L14.9466 19.125L13.6933 17.8717C12.9944 18.2837 12.1692 18.4268 11.3724 18.274C10.5756 18.1212 9.86193 17.683 9.36509 17.0416C8.86824 16.4002 8.62238 15.5996 8.67359 14.7899C8.7248 13.9802 9.06956 13.217 9.64326 12.6433C10.2169 12.0696 10.9802 11.7248 11.7899 11.6736C12.5996 11.6224 13.4002 11.8683 14.0416 12.3651C14.683 12.8619 15.1211 13.5757 15.274 14.3725C15.4268 15.1693 15.2837 15.9944 14.8716 16.6933ZM12 16.6667C12.442 16.6667 12.8659 16.4911 13.1785 16.1785C13.491 15.8659 13.6666 15.442 13.6666 15C13.6666 14.558 13.491 14.134 13.1785 13.8215C12.8659 13.5089 12.442 13.3333 12 13.3333C11.558 13.3333 11.134 13.5089 10.8215 13.8215C10.5089 14.134 10.3333 14.558 10.3333 15C10.3333 15.442 10.5089 15.8659 10.8215 16.1785C11.134 16.4911 11.558 16.6667 12 16.6667Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">Cadastro de tipos de fiscal</div>
            </div>
          </router-link>
          <router-link
            to="/fiscalizacoes"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            v-if="this.userType === 1"
            :class="verifyIfRouteIsActive('/fiscalizacoes') && 'active-item'"
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.0259 12.8475L17.5951 16.4158L16.4159 17.595L12.8476 14.0258C11.5199 15.0902 9.86842 15.6691 8.16675 15.6667C4.02675 15.6667 0.666748 12.3067 0.666748 8.16667C0.666748 4.02667 4.02675 0.666672 8.16675 0.666672C12.3067 0.666672 15.6667 4.02667 15.6667 8.16667C15.6692 9.86834 15.0903 11.5198 14.0259 12.8475ZM12.3542 12.2292C13.4118 11.1416 14.0025 9.6837 14.0001 8.16667C14.0001 4.94334 11.3892 2.33334 8.16675 2.33334C4.94341 2.33334 2.33341 4.94334 2.33341 8.16667C2.33341 11.3892 4.94341 14 8.16675 14C9.68377 14.0024 11.1417 13.4118 12.2292 12.3542L12.3542 12.2292ZM9.14842 4.98001C8.90269 5.091 8.68756 5.25996 8.52149 5.47238C8.35542 5.68481 8.24337 5.93435 8.19495 6.1996C8.14653 6.46485 8.16319 6.73789 8.24349 6.99528C8.3238 7.25268 8.46535 7.48675 8.65601 7.67741C8.84667 7.86807 9.08074 8.00962 9.33814 8.08993C9.59553 8.17023 9.86857 8.18689 10.1338 8.13847C10.3991 8.09005 10.6486 7.978 10.861 7.81193C11.0735 7.64586 11.2424 7.43073 11.3534 7.18501C11.5724 7.89636 11.547 8.66054 11.2813 9.3558C11.0156 10.0511 10.5248 10.6374 9.88721 11.0213C9.24959 11.4053 8.50181 11.5648 7.76302 11.4745C7.02422 11.3841 6.33691 11.0491 5.81061 10.5228C5.28431 9.99651 4.9493 9.3092 4.85895 8.5704C4.7686 7.83161 4.92812 7.08383 5.31209 6.44621C5.69605 5.80859 6.28237 5.31783 6.97762 5.05211C7.67288 4.78639 8.43706 4.76101 9.14842 4.98001Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">Fiscalizações em campo</div>
            </div>
          </router-link>
        </div>

        <div
          class="d-flex"
          v-if="userType !== 2"
          @click="usersSection = !usersSection"
        >
          <p class="sidebar-section-title mt-4 pl-1">
            ZELADORES
            <svg
              class="arrow-handle"
              :class="{ 'rotate-arrow': !usersSection }"
              width="12"
              height="8"
              viewBox="0 0 12 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.00011 3.02341L1.87511 7.14841L0.696777 5.97008L6.00011 0.666748L11.3034 5.97008L10.1251 7.14841L6.00011 3.02341Z"
                fill="white"
              />
            </svg>
          </p>
        </div>

        <div class="mt-3" v-if="usersSection">
          <router-link
            to="/zeladores"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            v-if="this.userType === 1"
            :class="verifyIfRouteIsActive('/zeladores') && 'active-item'"
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.6665 15.6666V11.5H7.33317V15.6666H14.8332V9.83329H3.1665V15.6666H5.6665ZM2.33317 8.16663H15.6665V5.66663H10.6665V2.33329H7.33317V5.66663H2.33317V8.16663ZM1.49984 16.5V9.83329H0.666504V4.83329C0.666504 4.61228 0.754301 4.40032 0.910582 4.24404C1.06686 4.08776 1.27882 3.99996 1.49984 3.99996H5.6665V1.49996C5.6665 1.27895 5.7543 1.06698 5.91058 0.910704C6.06686 0.754423 6.27882 0.666626 6.49984 0.666626H11.4998C11.7209 0.666626 11.9328 0.754423 12.0891 0.910704C12.2454 1.06698 12.3332 1.27895 12.3332 1.49996V3.99996H16.4998C16.7208 3.99996 16.9328 4.08776 17.0891 4.24404C17.2454 4.40032 17.3332 4.61228 17.3332 4.83329V9.83329H16.4998V16.5C16.4998 16.721 16.412 16.9329 16.2558 17.0892C16.0995 17.2455 15.8875 17.3333 15.6665 17.3333H2.33317C2.11216 17.3333 1.9002 17.2455 1.74391 17.0892C1.58763 16.9329 1.49984 16.721 1.49984 16.5Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">{{ $t("users") }}</div>
            </div>
          </router-link>

          <router-link
            to="/importacao"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            v-if="this.userType === 1 && !amaCandidate"
            :class="verifyIfRouteIsActive('/importacao') && 'active-item'"
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.00016 11.6667V13.3334C5.67408 13.3334 4.40231 13.8602 3.46463 14.7978C2.52695 15.7355 2.00016 17.0073 2.00016 18.3334H0.333496C0.333496 16.5653 1.03588 14.8696 2.28612 13.6193C3.53636 12.3691 5.23205 11.6667 7.00016 11.6667ZM7.00016 10.8334C4.23766 10.8334 2.00016 8.59587 2.00016 5.83337C2.00016 3.07087 4.23766 0.833374 7.00016 0.833374C9.76266 0.833374 12.0002 3.07087 12.0002 5.83337C12.0002 8.59587 9.76266 10.8334 7.00016 10.8334ZM7.00016 9.16671C8.84183 9.16671 10.3335 7.67504 10.3335 5.83337C10.3335 3.99171 8.84183 2.50004 7.00016 2.50004C5.1585 2.50004 3.66683 3.99171 3.66683 5.83337C3.66683 7.67504 5.1585 9.16671 7.00016 9.16671ZM12.0002 17.9167L9.551 19.2042L10.0185 16.4775L8.03766 14.5459L10.776 14.1475L12.0002 11.6667L13.2252 14.1475L15.9627 14.5459L13.9818 16.4775L14.4485 19.2042L12.0002 17.9167Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">Importação de usuários</div>
            </div>
          </router-link>

          <router-link
            to="/candidatos"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            v-if="this.userType === 1 && amaCandidate"
            :class="verifyIfRouteIsActive('/candidatos') && 'active-item'"
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.00016 11.6667V13.3334C5.67408 13.3334 4.40231 13.8602 3.46463 14.7978C2.52695 15.7355 2.00016 17.0073 2.00016 18.3334H0.333496C0.333496 16.5653 1.03588 14.8696 2.28612 13.6193C3.53636 12.3691 5.23205 11.6667 7.00016 11.6667ZM7.00016 10.8334C4.23766 10.8334 2.00016 8.59587 2.00016 5.83337C2.00016 3.07087 4.23766 0.833374 7.00016 0.833374C9.76266 0.833374 12.0002 3.07087 12.0002 5.83337C12.0002 8.59587 9.76266 10.8334 7.00016 10.8334ZM7.00016 9.16671C8.84183 9.16671 10.3335 7.67504 10.3335 5.83337C10.3335 3.99171 8.84183 2.50004 7.00016 2.50004C5.1585 2.50004 3.66683 3.99171 3.66683 5.83337C3.66683 7.67504 5.1585 9.16671 7.00016 9.16671ZM12.0002 17.9167L9.551 19.2042L10.0185 16.4775L8.03766 14.5459L10.776 14.1475L12.0002 11.6667L13.2252 14.1475L15.9627 14.5459L13.9818 16.4775L14.4485 19.2042L12.0002 17.9167Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">{{ $t("candidates") }}</div>
            </div>
          </router-link>

          <router-link
            to="/contratos-zeladores"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            v-if="this.userType === 1 && amaCandidate"
            :class="
              verifyIfRouteIsActive('/contratos-zeladores') && 'active-item'
            "
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.00016 11.6667V13.3334C5.67408 13.3334 4.40231 13.8602 3.46463 14.7978C2.52695 15.7355 2.00016 17.0073 2.00016 18.3334H0.333496C0.333496 16.5653 1.03588 14.8696 2.28612 13.6193C3.53636 12.3691 5.23205 11.6667 7.00016 11.6667ZM7.00016 10.8334C4.23766 10.8334 2.00016 8.59587 2.00016 5.83337C2.00016 3.07087 4.23766 0.833374 7.00016 0.833374C9.76266 0.833374 12.0002 3.07087 12.0002 5.83337C12.0002 8.59587 9.76266 10.8334 7.00016 10.8334ZM7.00016 9.16671C8.84183 9.16671 10.3335 7.67504 10.3335 5.83337C10.3335 3.99171 8.84183 2.50004 7.00016 2.50004C5.1585 2.50004 3.66683 3.99171 3.66683 5.83337C3.66683 7.67504 5.1585 9.16671 7.00016 9.16671ZM12.0002 17.9167L9.551 19.2042L10.0185 16.4775L8.03766 14.5459L10.776 14.1475L12.0002 11.6667L13.2252 14.1475L15.9627 14.5459L13.9818 16.4775L14.4485 19.2042L12.0002 17.9167Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">Contratos dos zeladores</div>
            </div>
          </router-link>

          <router-link
            to="/chat"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            v-if="this.userType === 3"
            :class="verifyIfRouteIsActive('/chat') && 'active-item'"
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    d="M2 8.994A5.99 5.99 0 0 1 8 3h8c3.313 0 6 2.695 6 5.994V21H8c-3.313 0-6-2.695-6-5.994V8.994zM20 19V8.994A4.004 4.004 0 0 0 16 5H8a3.99 3.99 0 0 0-4 3.994v6.012A4.004 4.004 0 0 0 8 19h12zm-6-8h2v2h-2v-2zm-6 0h2v2H8v-2z"
                    fill="rgba(0,177,235,1)"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">{{ $t("Chat") }}</div>
            </div>
          </router-link>
        </div>

        <div
          class="d-flex"
          v-if="userType !== 3"
          @click="documentsSection = !documentsSection"
        >
          <p class="sidebar-section-title mt-4 pl-1">
            DOCUMENTOS
            <svg
              class="arrow-handle"
              :class="{ 'rotate-arrow': !documentsSection }"
              width="12"
              height="8"
              viewBox="0 0 12 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.00011 3.02341L1.87511 7.14841L0.696777 5.97008L6.00011 0.666748L11.3034 5.97008L10.1251 7.14841L6.00011 3.02341Z"
                fill="white"
              />
            </svg>
          </p>
        </div>

        <div class="mt-3" v-if="documentsSection">
          <router-link
            to="/contratos-distratos"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            v-if="this.userType === 1"
            :class="
              verifyIfRouteIsActive('/contratos-distratos') && 'active-item'
            "
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="16"
                  height="18"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.5 2.33329H2.16667V15.6666H13.8333V5.66663H10.5V2.33329ZM0.5 1.49329C0.5 1.03663 0.8725 0.666626 1.3325 0.666626H11.3333L15.5 4.83329V16.4941C15.5008 16.6036 15.48 16.7121 15.4388 16.8135C15.3976 16.9149 15.3369 17.0072 15.2601 17.0851C15.1832 17.163 15.0918 17.225 14.991 17.2676C14.8902 17.3102 14.7819 17.3325 14.6725 17.3333H1.3275C1.10865 17.3318 0.899181 17.2442 0.744348 17.0895C0.589515 16.9349 0.501746 16.7255 0.5 16.5066V1.49329ZM8 8.58329C7.44747 8.58329 6.91756 8.3638 6.52686 7.9731C6.13616 7.5824 5.91667 7.05249 5.91667 6.49996C5.91667 5.94742 6.13616 5.41752 6.52686 5.02682C6.91756 4.63612 7.44747 4.41663 8 4.41663C8.55254 4.41663 9.08244 4.63612 9.47314 5.02682C9.86384 5.41752 10.0833 5.94742 10.0833 6.49996C10.0833 7.05249 9.86384 7.5824 9.47314 7.9731C9.08244 8.3638 8.55254 8.58329 8 8.58329ZM4.2725 13.1666C4.37352 12.2486 4.80974 11.4002 5.49757 10.7839C6.1854 10.1676 7.07646 9.8268 8 9.8268C8.92354 9.8268 9.8146 10.1676 10.5024 10.7839C11.1903 11.4002 11.6265 12.2486 11.7275 13.1666H4.2725Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">Contratos Base</div>
            </div>
          </router-link>

          <router-link
            to="/laudo-tecnico-mensal"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            v-if="this.userType === 1 || this.userType === 2"
            :class="
              verifyIfRouteIsActive('/laudo-tecnico-mensal') && 'active-item'
            "
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.6667 0.666748C15.1267 0.666748 15.5 1.04008 15.5 1.50008V4.63091L13.8333 6.29758V2.33341H2.16667V15.6667H13.8333V13.3684L15.5 11.7017V16.5001C15.5 16.9601 15.1267 17.3334 14.6667 17.3334H1.33333C0.873333 17.3334 0.5 16.9601 0.5 16.5001V1.50008C0.5 1.04008 0.873333 0.666748 1.33333 0.666748H14.6667ZM16.1483 6.34008L17.3267 7.51841L10.845 14.0001L9.665 13.9984L9.66667 12.8217L16.1483 6.34008ZM8.83333 9.00008V10.6667H4.66667V9.00008H8.83333ZM11.3333 5.66675V7.33341H4.66667V5.66675H11.3333Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">{{ $t("technicalReports") }}</div>
            </div>
          </router-link>

          <!--  <router-link
          to="/relatorioAdministrativo"
          class="d-flex align-items-center text-decoration-none mb-2 menu-item"
          v-if="this.userType === 1"
          :class="
            verifyIfRouteIsActive('/relatorioAdministrativo') && 'active-item'
          "
        >
          <div class="d-flex ml-1">
            <div class="icon-grid">
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 5.66675V16.4942C15.5008 16.6037 15.48 16.7122 15.4388 16.8136C15.3976 16.915 15.3369 17.0073 15.2601 17.0852C15.1832 17.1631 15.0918 17.2252 14.991 17.2678C14.8902 17.3103 14.7819 17.3327 14.6725 17.3334H1.3275C1.10818 17.3334 0.897826 17.2463 0.742664 17.0913C0.587501 16.9363 0.500221 16.7261 0.5 16.5067V1.49341C0.5 1.04591 0.874167 0.666748 1.335 0.666748H10.4975L15.5 5.66675ZM13.8333 6.50008H9.66667V2.33341H2.16667V15.6667H13.8333V6.50008ZM4.66667 4.83341H7.16667V6.50008H4.66667V4.83341ZM4.66667 8.16675H11.3333V9.83341H4.66667V8.16675ZM4.66667 11.5001H11.3333V13.1667H4.66667V11.5001Z"
                  fill="#00B1EB"
                />
              </svg>
            </div>
            <div class="sidebar-link-label">
              {{ $t("Administrative Report") }}
            </div>
          </div>
        </router-link> -->

          <router-link
            to="/relatorios"
            class="d-flex align-items-center text-decoration-none mb-2 menu-item"
            v-if="this.userType === 1 || this.userType === 2"
            :class="verifyIfRouteIsActive('/relatorios') && 'active-item'"
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="16"
                  height="18"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5 5.66675V16.4942C15.5008 16.6037 15.48 16.7122 15.4388 16.8136C15.3976 16.915 15.3369 17.0073 15.2601 17.0852C15.1832 17.1631 15.0918 17.2252 14.991 17.2678C14.8902 17.3103 14.7819 17.3327 14.6725 17.3334H1.3275C1.10818 17.3334 0.897826 17.2463 0.742664 17.0913C0.587501 16.9363 0.500221 16.7261 0.5 16.5067V1.49341C0.5 1.04591 0.874167 0.666748 1.335 0.666748H10.4975L15.5 5.66675ZM13.8333 6.50008H9.66667V2.33341H2.16667V15.6667H13.8333V6.50008ZM4.66667 4.83341H7.16667V6.50008H4.66667V4.83341ZM4.66667 8.16675H11.3333V9.83341H4.66667V8.16675ZM4.66667 11.5001H11.3333V13.1667H4.66667V11.5001Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>
              <div class="sidebar-link-label">{{ $t("reports") }}</div>
            </div>
          </router-link>

          <!-- <router-link
          to="/funil"
          class="d-flex align-items-center text-decoration-none"
          v-if="this.userType === 1"
        >
          <div class="d-flex ml-1 mb-4">
            <div class="icon-grid">
              <svg
                width="18"
                height="16"
                viewBox="0 0 18 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.49984 0.5H16.4998C16.7208 0.5 16.9328 0.587797 17.0891 0.744078C17.2454 0.900358 17.3332 1.11232 17.3332 1.33333V14.6667C17.3332 14.8877 17.2454 15.0996 17.0891 15.2559C16.9328 15.4122 16.7208 15.5 16.4998 15.5H1.49984C1.27882 15.5 1.06686 15.4122 0.910582 15.2559C0.754301 15.0996 0.666504 14.8877 0.666504 14.6667V1.33333C0.666504 1.11232 0.754301 0.900358 0.910582 0.744078C1.06686 0.587797 1.27882 0.5 1.49984 0.5ZM2.33317 2.16667V13.8333H15.6665V2.16667H2.33317ZM4.83317 8.83333H6.49984V12.1667H4.83317V8.83333ZM8.1665 3.83333H9.83317V12.1667H8.1665V3.83333ZM11.4998 6.33333H13.1665V12.1667H11.4998V6.33333Z"
                  fill="#00B1EB"
                />
              </svg>
            </div>
            <div class="sidebar-link-label">{{ $t("funnel") }}</div>
          </div>
        </router-link> -->
        </div>
      </div>

      <div class="d-flex" @click="configSection = !configSection">
        <p class="sidebar-section-title mt-4 pl-1">
          CONFIGURAÇÕES
          <svg
            class="arrow-handle"
            :class="{ 'rotate-arrow': !configSection }"
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.00011 3.02341L1.87511 7.14841L0.696777 5.97008L6.00011 0.666748L11.3034 5.97008L10.1251 7.14841L6.00011 3.02341Z"
              fill="white"
            />
          </svg>
        </p>
      </div>

      <div class="mt-2" v-if="configSection">
        <router-link
          to="/tipos-tag"
          class="d-flex align-items-center text-decoration-none mb-2 menu-item"
          v-if="this.userType === 1"
          :class="verifyIfRouteIsActive('/tipos-tag') && 'active-item'"
        >
          <div class="d-flex ml-1">
            <div class="icon-grid">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.08353 0.75L16.3327 1.92917L17.511 10.1792L9.85103 17.8392C9.69476 17.9954 9.48284 18.0832 9.26187 18.0832C9.0409 18.0832 8.82897 17.9954 8.6727 17.8392L0.4227 9.58917C0.266474 9.43289 0.178711 9.22097 0.178711 9C0.178711 8.77903 0.266474 8.56711 0.4227 8.41083L8.08353 0.75ZM8.6727 2.51833L2.1902 9L9.26187 16.0708L15.7435 9.58917L14.8602 3.40167L8.6727 2.51833ZM10.4394 7.82167C10.1267 7.50893 9.95116 7.08482 9.95123 6.64262C9.95127 6.42367 9.99444 6.20687 10.0783 6.0046C10.1621 5.80233 10.2849 5.61855 10.4398 5.46375C10.5946 5.30895 10.7785 5.18617 10.9808 5.10242C11.1831 5.01867 11.3999 4.97558 11.6188 4.97562C12.061 4.9757 12.4851 5.15143 12.7977 5.46417C13.1103 5.7769 13.2859 6.20102 13.2858 6.64321C13.2858 7.08541 13.11 7.50946 12.7973 7.82208C12.4845 8.13471 12.0604 8.31029 11.6182 8.31021C11.176 8.31014 10.752 8.1344 10.4394 7.82167Z"
                  fill="#00B1EB"
                />
              </svg>
            </div>
            <div class="sidebar-link-label">Cadastro de tags</div>
          </div>
        </router-link>

        <router-link
          to="/tipos-usuario"
          class="d-flex align-items-center text-decoration-none mb-2 menu-item"
          v-if="this.userType === 1"
          :class="verifyIfRouteIsActive('/tipos-usuario') && 'active-item'"
        >
          <div class="d-flex ml-1">
            <div class="icon-grid">
              <svg
                width="14"
                height="19"
                viewBox="0 0 14 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.333496 18.3334C0.333496 16.5653 1.03588 14.8696 2.28612 13.6193C3.53636 12.3691 5.23205 11.6667 7.00016 11.6667C8.76827 11.6667 10.464 12.3691 11.7142 13.6193C12.9645 14.8696 13.6668 16.5653 13.6668 18.3334H12.0002C12.0002 17.0073 11.4734 15.7355 10.5357 14.7978C9.59801 13.8602 8.32624 13.3334 7.00016 13.3334C5.67408 13.3334 4.40231 13.8602 3.46463 14.7978C2.52695 15.7355 2.00016 17.0073 2.00016 18.3334H0.333496ZM7.00016 10.8334C4.23766 10.8334 2.00016 8.59587 2.00016 5.83337C2.00016 3.07087 4.23766 0.833374 7.00016 0.833374C9.76266 0.833374 12.0002 3.07087 12.0002 5.83337C12.0002 8.59587 9.76266 10.8334 7.00016 10.8334ZM7.00016 9.16671C8.84183 9.16671 10.3335 7.67504 10.3335 5.83337C10.3335 3.99171 8.84183 2.50004 7.00016 2.50004C5.1585 2.50004 3.66683 3.99171 3.66683 5.83337C3.66683 7.67504 5.1585 9.16671 7.00016 9.16671Z"
                  fill="#00B1EB"
                />
              </svg>
            </div>
            <div class="sidebar-link-label">{{ $t("usersManagers") }}</div>
          </div>
        </router-link>

        <router-link
          to="/configuracoes"
          class="d-flex align-items-center text-decoration-none mb-2 menu-item"
          v-if="this.userType === 1"
          :class="verifyIfRouteIsActive('/configuracoes') && 'active-item'"
        >
          <div class="d-flex ml-1">
            <div class="icon-grid">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.78326 13.1666C1.43099 12.5575 1.15715 11.9062 0.968262 11.2283C1.37935 11.0192 1.72459 10.7005 1.96579 10.3074C2.20698 9.91428 2.33473 9.46211 2.33491 9.0009C2.33508 8.5397 2.20767 8.08743 1.96676 7.69414C1.72586 7.30085 1.38086 6.98187 0.969928 6.77247C1.34663 5.41038 2.06387 4.1666 3.05409 3.15831C3.44084 3.40974 3.88961 3.54928 4.35074 3.56146C4.81188 3.57364 5.26739 3.458 5.66687 3.22733C6.06635 2.99667 6.39422 2.65997 6.6142 2.25451C6.83418 1.84904 6.93768 1.39062 6.91326 0.929974C8.28169 0.576326 9.71762 0.5769 11.0858 0.931641C11.0616 1.39228 11.1653 1.85063 11.3854 2.25598C11.6056 2.66133 11.9336 2.99787 12.3331 3.22836C12.7327 3.45885 13.1882 3.5743 13.6493 3.56193C14.1104 3.54957 14.5591 3.40988 14.9458 3.15831C15.4283 3.64997 15.8566 4.20914 16.2166 4.83331C16.5774 5.45747 16.8474 6.10831 17.0316 6.77164C16.6205 6.98073 16.2753 7.29945 16.0341 7.69256C15.7929 8.08567 15.6651 8.53784 15.665 8.99905C15.6648 9.46025 15.7922 9.91252 16.0331 10.3058C16.274 10.6991 16.619 11.0181 17.0299 11.2275C16.6532 12.5896 15.936 13.8333 14.9458 14.8416C14.559 14.5902 14.1102 14.4507 13.6491 14.4385C13.188 14.4263 12.7325 14.5419 12.333 14.7726C11.9335 15.0033 11.6056 15.34 11.3857 15.7454C11.1657 16.1509 11.0622 16.6093 11.0866 17.07C9.71817 17.4236 8.28224 17.423 6.91409 17.0683C6.9383 16.6077 6.83459 16.1493 6.61445 15.744C6.3943 15.3386 6.0663 15.0021 5.66674 14.7716C5.26718 14.5411 4.81164 14.4257 4.35053 14.438C3.88943 14.4504 3.44073 14.5901 3.05409 14.8416C2.56159 14.3391 2.13459 13.7763 1.78326 13.1666ZM6.49993 13.33C7.38795 13.8422 8.05563 14.6642 8.37493 15.6383C8.79076 15.6775 9.20826 15.6783 9.62409 15.6391C9.9436 14.6649 10.6116 13.8428 11.4999 13.3308C12.3876 12.8172 13.4337 12.6495 14.4374 12.86C14.6791 12.52 14.8874 12.1575 15.0608 11.7783C14.377 11.0145 13.9992 10.0251 13.9999 8.99997C13.9999 7.94997 14.3916 6.96914 15.0608 6.22164C14.8862 5.8426 14.677 5.4805 14.4358 5.13997C13.4327 5.35023 12.3873 5.18287 11.4999 4.66997C10.6119 4.15778 9.94422 3.33579 9.62493 2.36164C9.2091 2.32247 8.79159 2.32164 8.37576 2.36081C8.05626 3.3351 7.38826 4.15711 6.49993 4.66914C5.61225 5.18274 4.56616 5.35041 3.56243 5.13997C3.32123 5.48021 3.11254 5.84236 2.9391 6.22164C3.6229 6.98544 4.00066 7.9748 3.99993 8.99997C3.99993 10.05 3.60826 11.0308 2.9391 11.7783C3.11365 12.1574 3.32288 12.5194 3.5641 12.86C4.56719 12.6497 5.6126 12.8171 6.49993 13.33ZM8.99993 11.5C8.33689 11.5 7.701 11.2366 7.23216 10.7677C6.76332 10.2989 6.49993 9.66302 6.49993 8.99997C6.49993 8.33693 6.76332 7.70105 7.23216 7.23221C7.701 6.76337 8.33689 6.49997 8.99993 6.49997C9.66297 6.49997 10.2989 6.76337 10.7677 7.23221C11.2365 7.70105 11.4999 8.33693 11.4999 8.99997C11.4999 9.66302 11.2365 10.2989 10.7677 10.7677C10.2989 11.2366 9.66297 11.5 8.99993 11.5ZM8.99993 9.83331C9.22094 9.83331 9.4329 9.74551 9.58918 9.58923C9.74546 9.43295 9.83326 9.22099 9.83326 8.99997C9.83326 8.77896 9.74546 8.567 9.58918 8.41072C9.4329 8.25444 9.22094 8.16664 8.99993 8.16664C8.77891 8.16664 8.56695 8.25444 8.41067 8.41072C8.25439 8.567 8.1666 8.77896 8.1666 8.99997C8.1666 9.22099 8.25439 9.43295 8.41067 9.58923C8.56695 9.74551 8.77891 9.83331 8.99993 9.83331Z"
                  fill="#00B1EB"
                />
              </svg>
            </div>
            <div class="sidebar-link-label">{{ $t("settings") }}</div>
          </div>
        </router-link>

        <div class="mb-2 menu-item">
          <a
            style="text-decoration: none"
            target="_blank"
            href="https://wa.me/554137730723"
          >
            <div class="d-flex ml-1">
              <div class="icon-grid">
                <svg
                  width="18"
                  height="17"
                  viewBox="0 0 18 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.80234 12.1667H15.6665V2.16667H2.33317V13.3208L3.80234 12.1667ZM4.379 13.8333L0.666504 16.75V1.33333C0.666504 1.11232 0.754301 0.900358 0.910582 0.744078C1.06686 0.587797 1.27882 0.5 1.49984 0.5H16.4998C16.7208 0.5 16.9328 0.587797 17.0891 0.744078C17.2454 0.900358 17.3332 1.11232 17.3332 1.33333V13C17.3332 13.221 17.2454 13.433 17.0891 13.5893C16.9328 13.7455 16.7208 13.8333 16.4998 13.8333H4.379ZM8.1665 9.66667H9.83317V11.3333H8.1665V9.66667ZM6.139 5.34417C6.24727 4.80233 6.50719 4.30237 6.8885 3.90248C7.26981 3.50259 7.75685 3.2192 8.29293 3.0853C8.82901 2.95139 9.39209 2.97248 9.91666 3.1461C10.4412 3.31971 10.9057 3.63873 11.256 4.06602C11.6064 4.4933 11.8282 5.01129 11.8956 5.55971C11.9631 6.10813 11.8734 6.66443 11.637 7.16387C11.4007 7.66332 11.0273 8.08537 10.5605 8.38092C10.0936 8.67646 9.55239 8.83335 8.99984 8.83333H8.1665V7.16667H8.99984C9.23657 7.16665 9.46843 7.09941 9.66844 6.97277C9.86845 6.84614 10.0284 6.6653 10.1296 6.45132C10.2309 6.23734 10.2693 5.999 10.2404 5.76404C10.2115 5.52908 10.1165 5.30715 9.96636 5.12409C9.81626 4.94103 9.61726 4.80436 9.39252 4.72997C9.16778 4.65559 8.92653 4.64656 8.69686 4.70392C8.46718 4.76129 8.25852 4.88269 8.09514 5.05401C7.93177 5.22533 7.8204 5.43953 7.774 5.67167L6.139 5.34417Z"
                    fill="#00B1EB"
                  />
                </svg>
              </div>

              <div class="sidebar-link-label">Suporte</div>
            </div>
          </a>
        </div>

        <router-link
          to="/senha"
          class="d-flex align-items-center text-decoration-none mb-2 menu-item"
          :class="verifyIfRouteIsActive('/senha') && 'active-item'"
        >
          <div class="d-flex ml-1">
            <div class="icon-grid">
              <svg
                width="16"
                height="19"
                viewBox="0 0 16 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 6.66665H14.6667C14.8877 6.66665 15.0996 6.75444 15.2559 6.91072C15.4122 7.067 15.5 7.27897 15.5 7.49998V17.5C15.5 17.721 15.4122 17.933 15.2559 18.0892C15.0996 18.2455 14.8877 18.3333 14.6667 18.3333H1.33333C1.11232 18.3333 0.900358 18.2455 0.744078 18.0892C0.587797 17.933 0.5 17.721 0.5 17.5V7.49998C0.5 7.27897 0.587797 7.067 0.744078 6.91072C0.900358 6.75444 1.11232 6.66665 1.33333 6.66665H3V5.83331C3 4.50723 3.52678 3.23546 4.46447 2.29778C5.40215 1.3601 6.67392 0.833313 8 0.833313C9.32608 0.833313 10.5979 1.3601 11.5355 2.29778C12.4732 3.23546 13 4.50723 13 5.83331V6.66665ZM2.16667 8.33331V16.6666H13.8333V8.33331H2.16667ZM7.16667 11.6666H8.83333V13.3333H7.16667V11.6666ZM3.83333 11.6666H5.5V13.3333H3.83333V11.6666ZM10.5 11.6666H12.1667V13.3333H10.5V11.6666ZM11.3333 6.66665V5.83331C11.3333 4.94926 10.9821 4.10141 10.357 3.47629C9.7319 2.85117 8.88406 2.49998 8 2.49998C7.11594 2.49998 6.2681 2.85117 5.64298 3.47629C5.01786 4.10141 4.66667 4.94926 4.66667 5.83331V6.66665H11.3333Z"
                  fill="#00B1EB"
                />
              </svg>
            </div>
            <div class="sidebar-link-label">{{ $t("changePwd") }}</div>
          </div>
        </router-link>
        <div class="d-flex ml-1 mb-5 menu-item pointer" @click="logout">
          <div class="icon-grid">
            <svg
              width="17"
              height="18"
              viewBox="0 0 17 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.16683 17.3334C0.945816 17.3334 0.733854 17.2456 0.577574 17.0893C0.421294 16.933 0.333496 16.721 0.333496 16.5V1.50002C0.333496 1.27901 0.421294 1.06704 0.577574 0.910765C0.733854 0.754484 0.945816 0.666687 1.16683 0.666687H12.8335C13.0545 0.666687 13.2665 0.754484 13.4228 0.910765C13.579 1.06704 13.6668 1.27901 13.6668 1.50002V4.00002H12.0002V2.33335H2.00016V15.6667H12.0002V14H13.6668V16.5C13.6668 16.721 13.579 16.933 13.4228 17.0893C13.2665 17.2456 13.0545 17.3334 12.8335 17.3334H1.16683ZM12.0002 12.3334V9.83335H6.16683V8.16669H12.0002V5.66669L16.1668 9.00002L12.0002 12.3334Z"
                fill="#00B1EB"
              />
            </svg>
          </div>
          <div class="sidebar-link-label">{{ $t("logOut") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import services from "../services";

import { decrypt } from "../utils/decrypt";

export default {
  data() {
    return {
      userType: null,
      userName: "",
      adminSection: true,
      usersSection: false,
      documentsSection: false,
      supervisorSection: false,
      configSection: false,
      actualRoute: this.$router.currentRoute.path,
      amaCandidate: false,
    };
  },
  mounted: async function () {
    this.$store.dispatch("global/setUser").then(() => {
      const user = this.$store.state.global.user;
      this.userType = user.usuario_gestor_tipo_id;
      this.userName = user.usuario_gestor_nome;
    });

    if (localStorage.getItem("config-500")) {
      const encrypted = localStorage.getItem("config-500");
      const decrypted = decrypt(encrypted);
      const config = JSON.parse(decrypted);
      this.amaCandidate = config.candidate.config_valor === "1" ? true : false;
    }
  },
  methods: {
    verifyIfRouteIsActive(route) {
      return this.actualRoute === route;
    },
    verifyIfRouteContains(route) {
      return this.actualRoute.includes(route);
    },
    getConfig500() {
      if (localStorage.getItem("config-500")) {
        const encrypted = localStorage.getItem("config-500");
        const decrypted = decrypt(encrypted);
        const config = JSON.parse(decrypted);
        return +config.config_valor;
      }
      return 1;
    },
    async logout() {
      const encrypted = localStorage.getItem("ama");
      const decrypted = decrypt(encrypted);
      const user = JSON.parse(decrypted);
      const response = await services.auth.logout();
      if (response) {
        if (user.usuario_cidade === "Curitiba/PR") {
          this.$router.push("/curitiba");
        } else if (user.usuario_cidade === "Florianópolis/SC") {
          this.$router.push("/florianopolis");
        } else if (user.usuario_cidade === "Osasco/SP") {
          this.$router.push("/osasco");
        } else if (user.usuario_cidade === "Apucarana/PR") {
          this.$router.push("/apucarana");
        } else if (user.usuario_cidade === "Paranaguá/PR") {
          this.$router.push("/paranagua");
        } else if (user.usuario_cidade === "Ribeirão Preto/SP") {
          this.$router.push("/ribeirao-preto");
        } else if (user.usuario_cidade === "Manaus/AM") {
          this.$router.push("/manaus");
        } else if (user.usuario_cidade === "São José dos Pinhais/PR") {
          this.$router.push("/sao-jose-pinhais");
        } else if (user.usuario_cidade === "Recife/PE") {
          this.$router.push("/recife");
        } else if (user.usuario_cidade === "Rio de Janeiro/RJ") {
          this.$router.push("/rio-de-janeiro");
        } else if (user.usuario_cidade === "Guarulhos/SP") {
          this.$router.push("/guarulhos");
        } else if (user.usuario_cidade === "Belo Horizonte/MG") {
          this.$router.push("/belo-horizonte");
        } else if (user.usuario_cidade === "Muriaé/MG") {
          this.$router.push("/muriae");
        }
      }
    },
    routeTo(route) {
      this.$router.push(route);
    },
    homeRoute() {
      if (this.$router.currentRoute.path === "/dashboard") {
        window.location.reload();
      } else {
        this.$router.push("/dashboard");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.welcome-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 8px;
}

.sidebar-welcome {
  font-family: "Open Sans";
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: -0.011em;
  color: #ffffff;
}

.sidebar-link-label {
  font-family: "OpenSans-Regular";
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  letter-spacing: -0.006em;
  color: #ffffff;
  margin: 0;

  &:hover {
    color: #00b1eb;
  }
}

.active-item {
  background: #fff;

  .sidebar-link-label {
    color: #00b1eb;
  }
}

.menu-item {
  padding: 8px 10px;
  border-radius: 12px;
  position: relative;
  left: -8px;
  margin-right: 8px;

  &:hover {
    outline: 2px solid #00b1eb;
    .sidebar-link-label {
      color: #00b1eb;
      font-weight: 600;
    }
  }
}

.close-icon:hover {
  opacity: 0.7;
}

.rotate-arrow {
  transform: rotate(180deg);
}

.divisor {
  margin-top: 32px;
  margin-bottom: 8px;
  border: 1px solid #00b1eb;
  margin-right: 12px;
}

.icon-grid {
  width: 16px;
  margin-right: 16px;
  .svg {
    width: 20px;
  }
}

.sidebar-section-title {
  font-family: "Poppins";
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: #ffffff;
  padding-left: -16px !important;
  width: 100%;
  position: relative;
}

.arrow-handle {
  position: absolute;
  right: 14px;
  top: 1px;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
}

.sidebar-system {
  position: fixed;
  top: 0;
  width: 310px;
  z-index: 99999999999;
  background-color: #003366 !important;
  overflow-y: auto;
  height: 100%;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.sidebar-system::-webkit-scrollbar {
  display: none;
}

@media (max-width: 768px) {
  .sidebar-system {
    width: 100%;
  }
}
</style>
